import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import SolutionExtras, { SolutionSeo } from '../../components/SolutionExtras';
import { SOLUTIONS } from '../../data/solutions';

const S = SOLUTIONS.ucaas;
import { Cloud, Shield, Zap, Users, CheckCircle2, Settings } from 'lucide-react';

const UCaaS = () => {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <SolutionSeo s={S} name="UCaaS providers" />
      {/* Hero Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-5xl font-bold mb-6" style={{ color: '#0a1f2e' }}>
            UCaaS Provider Solutions
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            White-label unified communications solutions for service providers and resellers.
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="px-4 sm:px-6 lg:px-8 mb-16">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-bold mb-8" style={{ color: '#0a1f2e' }}>{S.featuresTitle}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Cloud className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>White-Label Platform</h3>
              <p className="text-gray-600">Fully customizable platform with your branding</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Shield className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Multi-Tenant Architecture</h3>
              <p className="text-gray-600">Serve multiple customers from a single platform</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Zap className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Rapid Deployment</h3>
              <p className="text-gray-600">Launch new services in minutes, not months</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Users className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Partner Portal</h3>
              <p className="text-gray-600">Complete partner management and provisioning tools</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <CheckCircle2 className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>Flexible Billing</h3>
              <p className="text-gray-600">Customizable pricing and billing models</p>
            </Card>
            <Card className="p-8 hover:shadow-xl transition-shadow">
              <Settings className="w-12 h-12 mb-4 text-[#c8ff00]" />
              <h3 className="text-xl font-bold mb-3" style={{ color: '#0a1f2e' }}>API Access</h3>
              <p className="text-gray-600">Full API for custom integrations and automation</p>
            </Card>
          </div>
        </div>
      </section>

      <SolutionExtras s={S} />

      {/* CTA */}
      <section className="px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Card className="p-12 text-center bg-gradient-to-br from-[#0a1f2e] to-[#0a2f3e] text-white">
            <h2 className="text-3xl font-bold mb-4">Become a VOIP2 Partner</h2>
            <p className="text-xl text-gray-300 mb-8">Start offering UCaaS services today</p>
            <Button 
              size="lg"
              style={{ backgroundColor: '#c8ff00', color: '#0a1f2e' }}
              className="hover:opacity-90 font-semibold"
              onClick={() => window.location.href = '/contact'}
            >
              Partner with Us
            </Button>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default UCaaS;